import './App.css';
import Login from './forms/Login.js'

function App() {
  return (
    <div className="App login-back">
      <header className="App-header">
        <Login />
      </header>
    </div>
  );
}

export default App;
